export default {
  copyright: '© Les Filles et les Sciences – An Electrifying Duo [YEAR]',
  credits: 'Site designed and developed by <em>Beet</em>',
}
